import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-navy border-y border-navy-light" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-navy-dark to-navy border border-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-135">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold-gradient" data-id="element-136"></div>

          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold/10 text-gold mb-8" data-id="element-137">
            <ShieldCheck size={48} data-id="element-138" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white" data-id="element-139">
            🛡️ Complete 7-Day Guarantee
          </h2>

          <div className="space-y-6 text-lg text-white/80 max-w-2xl mx-auto" data-id="element-140">
            <p data-id="element-141">
              Open the complete 6-in-1 system. Review all 5 bonus packs. Use
              them in your most challenging class this week.
            </p>
            <p className="font-medium text-white" data-id="element-142">
              If you feel your students did not respond better, or that the
              material did not save you hours of preparation time:
            </p>
            <p className="text-gold font-bold text-xl" data-id="element-143">
              We will refund 100% of your money. No questions. No forms. No
              complications.
            </p>
            <p className="text-sm text-white/60 mt-8" data-id="element-144">
              Because if the material does not deliver the value we promise, we
              do not want your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}